import React, { useState } from "react";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { db } from "../services/firebaseConfig";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "./AgentSignup.css";

const auth = getAuth();

const AgentSignup = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    try {
      const { email, password, fullName, phoneNumber } = formData;

      if (!/^\d{10,15}$/.test(phoneNumber)) {
        setError("Invalid phone number format.");
        return;
      }

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const agentId = userCredential.user.uid;

      await setDoc(doc(db, "agents", agentId), {
        agentId,
        fullName,
        email,
        phoneNumber,
        createdAt: serverTimestamp(),
        totalRegistrations: 0,
        totalCommission: 0,
      });

      console.log("✅ Agent registered successfully:", agentId);
      navigate("/agent-dashboard");

    } catch (error) {
      console.error("❌ Signup error:", error.message);
      setError(error.message);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card">
        <h2>Join as an Agent</h2>
        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSignup}>
          <div className="input-group">
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Full Name</label>
          </div>

          <div className="input-group">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label>Email Address</label>
          </div>

          <div className="input-group">
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
              placeholder=" "

            />
            <label>Phone Number</label>
          </div>

          <div className="input-group">
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder=" "

            />
            <label>Create Password</label>
          </div>

          <button type="submit">Sign Up</button>
        </form>
      </div>
    </div>
  );
};

export default AgentSignup;
